module.exports = __webpack_public_path__ + "media/masterplan.f797f2d4.jpg";